import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.931 25H28a2 2 0 0 0 2-2v-3c0-1.19-.152-2.374-.45-3.522a1 1 0 0 0-.053-.196A14 14 0 0 0 21.32 7.05 14 14 0 0 0 15.947 6c-6.35.022-11.667 4.324-13.373 10.133a1 1 0 0 0-.137.499A14.2 14.2 0 0 0 2 20.138V23a2 2 0 0 0 2 2h8.931m7.63-16.1A12 12 0 0 0 17 8.042V11a1 1 0 1 1-2 0V8.041c-4.733.396-8.683 3.585-10.262 7.91l2.833.758a1 1 0 0 1-.517 1.932l-2.845-.762A12.3 12.3 0 0 0 4 20.138V23h8.432l8.25-10.746a1 1 0 1 1 1.586 1.218L14.953 23H28v-3q0-1.074-.19-2.126l-2.864.767a1 1 0 0 1-.517-1.932l2.864-.767a12 12 0 0 0-2.824-4.444A12 12 0 0 0 20.56 8.9"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconGauge = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconGauge);
export default Memo;
